<div class="fd-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="fd-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="fd-header">
      <h2 class="fd-header__title">{{ "FINDING_DETAILS" | translate }}</h2>
      <div class="fd-header__actions">
        <button class="fd-header__btn">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </button>
        <button class="fd-header__btn fd-header__btn--close" (click)="close()">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="fd-body">
      <!-- Left Column -->
      <div class="fd-col">
        <!-- Info Card -->
        <div class="fd-info-card">
          <span class="fd-finding-id">{{ data?.findingId }}</span>
          <div class="fd-separator"></div>
          <div class="fd-meta">
            <div class="fd-meta__item">
              <img
                class="fd-meta__icon"
                src="assets/performance/finding-date.svg"
                alt="date"
              />
              <span>{{ data?.date }}</span>
            </div>
            <div class="fd-meta__item">
              <img
                class="fd-meta__icon"
                src="assets/performance/finding-person.svg"
                alt="assignee"
              />
              <span>{{ data?.assignee }}</span>
            </div>
            <div class="fd-meta__item">
              <img
                class="fd-meta__icon"
                src="assets/performance/finding-location.svg"
                alt="location"
              />
              <span>{{ data?.location }}</span>
            </div>
          </div>
        </div>

        <!-- Description Card -->
        <div class="fd-desc-card">
          <h4 class="fd-desc-card__title">{{ "VPC.FORM_DESC" | translate }}</h4>
          <p class="fd-desc-card__text">
            {{ descriptionText }}
            <ng-container *ngIf="isDescTruncated">
              ....
              <a class="fd-link" (click)="descExpanded = true">view more</a>
            </ng-container>
            <ng-container *ngIf="descExpanded">
              <a class="fd-link" (click)="descExpanded = false">view less</a>
            </ng-container>
          </p>
          <div class="fd-badges">
            <span class="fd-badge fd-badge--level">{{ data?.level }}</span>
            <span class="fd-badge fd-badge--type">{{ data?.findingType }}</span>
          </div>

          <div class="fd-pictures">
            <h4 class="fd-pictures__title">
              {{ "ACTION_CLOSURE.PICTURES" | translate }}
            </h4>
            <ng-container *ngIf="data?.pictures?.length; else noAttachment">
              <div class="fd-pictures__list">
                <div *ngFor="let pic of data?.pictures" class="fd-thumb">
                  <img [src]="pic" alt="" class="fd-thumb__img" />
                  <div class="fd-thumb__badge">
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <polygon
                        points="12,3 22,21 2,21"
                        fill="#f00014"
                        stroke="white"
                        stroke-width="1"
                      />
                      <line
                        x1="12"
                        y1="10"
                        x2="12"
                        y2="15"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <circle cx="12" cy="18" r="1" fill="white" />
                    </svg>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noAttachment>
              <div class="fd-no-attachment">
                <div class="fd-no-attachment__placeholder">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#b0b0b0"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                  </svg>
                </div>
                <span class="fd-no-attachment__label">No picture attached</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="fd-col">
        <ng-container *ngIf="data?.actions?.length; else noActions">
          <div
            *ngFor="let action of data?.actions; let i = index"
            class="fd-action-card"
          >
            <!-- Floating badge (top-right) -->
            <div class="fd-action-card__badge-outer">
              <img
                class="fd-action-card__badge"
                src="assets/performance/finding-edit.svg"
                alt="edit"
              />
            </div>

            <!-- Body -->
            <div class="fd-action-card__body">
              <p class="fd-action-card__desc">
                <span
                  class="fd-action-card__text"
                  [class.truncated]="!expandedActions.has(i)"
                  [class.expanded]="expandedActions.has(i)"
                >
                  {{ action.text }}
                </span>
                <span class="fd-action-card__more" (click)="toggleAction(i)">
                  {{ expandedActions.has(i) ? ("LESS_CONTENT" | translate) : ("MORE" | translate) }}
                </span>
              </p>

              <hr class="fd-action-card__divider" />

              <div class="fd-action-card__footer">
                <!-- Person -->
                <img
                  class="fd-action-card__icon"
                  src="assets/performance/action-assignee.svg"
                  alt="assignee"
                />
                <span class="fd-action-card__name">{{ action.assignee }}</span>

                <span class="fd-action-card__divider-v">|</span>

                <!-- Due date -->
                <img
                  class="fd-action-card__icon"
                  [src]="actionCalendarIcon(action)"
                  alt="due date"
                />
                <span
                  class="fd-action-card__date"
                  [ngClass]="actionDateClass(action)"
                >
                  {{ action.dueDate }}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noActions>
          <p class="fd-empty">{{ "NO_ACTIONS_ASSIGNED" | translate }}</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
